import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface WelcomePopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export const WelcomePopup: React.FC<WelcomePopupProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.5, opacity: 0 }}
            className="relative bg-gradient-to-br from-pink-100 to-purple-50 rounded-[2rem] p-8 max-w-md w-full shadow-2xl mx-auto my-auto"
          >
            {/* Close button - moved outside the main content */}
            <button
              onClick={onClose}
              className="absolute -top-2 -right-2 bg-white rounded-full p-2 text-gray-600 hover:text-gray-800 shadow-md z-10"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Main content container with proper spacing */}
            <div className="pt-16 pb-4"> {/* Added top padding to accommodate the floating SVG */}
              {/* Cute Baby SVG Illustration */}
              <motion.div
                initial={{ y: 20 }}
                animate={{ y: -20 }}
                transition={{ 
                  repeat: Infinity,
                  repeatType: "reverse",
                  duration: 2
                }}
                className="absolute -top-24 left-1/2 transform -translate-x-1/2"
              >
                <svg width="160" height="160" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {/* Baby face circle */}
                  <circle cx="100" cy="100" r="70" fill="#FFE0E5"/>
                  {/* Rosy cheeks */}
                  <circle cx="70" cy="110" r="15" fill="#FFB6C1" fillOpacity="0.5"/>
                  <circle cx="130" cy="110" r="15" fill="#FFB6C1" fillOpacity="0.5"/>
                  {/* Eyes */}
                  <circle cx="80" cy="90" r="8" fill="#4B0082"/>
                  <circle cx="120" cy="90" r="8" fill="#4B0082"/>
                  {/* Cute smile */}
                  <path d="M85 120 Q100 140 115 120" stroke="#4B0082" strokeWidth="4" strokeLinecap="round"/>
                  {/* Hair bows */}
                  <path d="M50 60 Q60 50 70 60 Q80 70 70 80 Q60 70 50 60Z" fill="#FF69B4"/>
                  <path d="M130 60 Q140 50 150 60 Q160 70 150 80 Q140 70 130 60Z" fill="#FF69B4"/>
                  {/* Sparkles */}
                  <circle cx="40" cy="40" r="3" fill="#FFD700"/>
                  <circle cx="160" cy="40" r="3" fill="#FFD700"/>
                  <circle cx="100" cy="30" r="3" fill="#FFD700"/>
                </svg>
              </motion.div>

              {/* Content */}
              <div className="mt-16 text-center">
                <h2 className="text-3xl font-bold text-purple-800 mb-2">
                  Welcome Back! 👋
                </h2>
                <p className="text-lg text-purple-600 mb-4">
                  We missed you!
                </p>
                <div className="bg-white rounded-xl p-4 mb-6 shadow-inner">
                  <p className="text-2xl font-bold text-pink-600">
                    Get 10% OFF
                  </p>
                  <p className="text-gray-600">
                  on orders above Kshs 5,000 today!
                  </p>
                </div>
                
                {/* CTA Button */}
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-full bg-gradient-to-r from-purple-600 to-pink-500 text-white py-3 px-6 rounded-full font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300"
                  onClick={onClose}
                >
                  Shop Now
                </motion.button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}; 